import { clearProject } from '../State/project';

export default () => async (dispatch) => {
  
  dispatch(clearProject());
  
}